import { CommonStorageKey } from "../const/common-storage-key";
import { CommonConst } from "../const";
import { ValidationUtil } from "./validation-util";
import { moment } from 'ngx-bootstrap/chronos/test/chain';

// 2022/07/04 Google Analytics対応(UA廃止) DEL
//declare var ga: Function;
declare var gtag: Function;
export class GaUtil {
  // ファイルダウンロード
  public static traceEvent_EachGroupCd(action: string, value: string) {
    // ユーザーID
    let userId: string = sessionStorage.getItem(CommonStorageKey.YUZAID);
    // グループコード
    let groupCd: string = sessionStorage.getItem(CommonStorageKey.GURUPUCODE);
    // グループ区分
    let groupKbn: string = sessionStorage.getItem(CommonStorageKey.GURUPUKUBUN);
    // 代行ユーザーフラグ
    let daikoFlg: string = sessionStorage.getItem(CommonStorageKey.DAIKOUFLG);

    let category: string = '';
    if (ValidationUtil.isEmpty(userId)) {
      category = 'グループ別機能利用集計';
    } else {
      category = 'グループ別機能利用集計(' + groupKbn + '-' + groupCd + ')';
    }

    if (((groupKbn == CommonConst.C_GURUPU_KUBUN_ICHIJITEN
      || groupKbn == CommonConst.C_GURUPU_KUBUN_NIJITEN
      || groupKbn == CommonConst.C_GURUPU_KUBUN_BUTSURYU_GAISHA
      // 強化テスト No.405 Start
      || groupKbn == CommonConst.C_GURUPU_KUBUN_BUTSURYU_CENTER
      // 強化テスト No.405 End
      || groupKbn == CommonConst.C_GURUPU_KUBUN_EIGYOSHO
      || groupKbn == CommonConst.C_GURUPU_KUBUN_JUCHU_CENTER)
      && daikoFlg == '0')
      || ValidationUtil.isEmpty(groupKbn)) {

      // 2022/06/15 Google Analytics対応(GA4追加) ADD START
      let JSTDate: Date = new Date(Date.now() + ((new Date().getTimezoneOffset() + (9 * 60)) * 60 * 1000));
      let json = { 'event_category': '', 'event_label': '', 'value': '', 'npn_event_datetime': '', 'npn_event_hour': '' };
      json.event_category = category;
      json.event_label = userId;
      json.value = value;
      json.npn_event_datetime = moment(JSTDate).format('YYYYMMDDHH');
      json.npn_event_hour = moment(JSTDate).format('HH');
      gtag('event', action, json);
      // 2022/06/15 Google Analytics対応(GA4追加) ADD END

      // 2022/07/04 Google Analytics対応(UA廃止) DEL START
      //if (!value) {
      //  ga('send', 'event', category, action, userId);
      //} else {
      //  ga('send', 'event', category, action, userId, value);
      //}
      // 2022/07/04 Google Analytics対応(UA廃止) DEL END
    }
    
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/shared/utility/ga-util.ts